import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEventData } from "types";
import { fetchEventDetails } from "./eventDetails.actions";
import { StatusState } from "store/types";

interface EventDetailState {
  data: IEventData | null;
  status: StatusState;
  error: string | null;
}

const initialState: EventDetailState = {
  data: null,
  status: StatusState.IDLE,
  error: null,
};

const eventDetailSlice = createSlice({
  name: "eventDetail",
  initialState,
  reducers: {
    resetEventDetails: () => initialState,
    setEventDetails: (state, action: PayloadAction<IEventData>) => {
      state.data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventDetails.pending, (state) => {
        state.status = StatusState.LOADING;
        state.error = null;
        state.data = null;
      })
      .addCase(fetchEventDetails.fulfilled, (state) => {
        state.status = StatusState.SUCCEEDED;
        state.error = null;
      })
      .addCase(fetchEventDetails.rejected, (state, action) => {
        state.status = StatusState.FAILED;
        state.error = action.payload as string;
        state.data = null;
      });
  },
});

export const { resetEventDetails, setEventDetails } = eventDetailSlice.actions;
const eventDetailsReducer = eventDetailSlice.reducer;
export default eventDetailsReducer;


